var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyPoster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 226,
    viewBox: "0 0 226 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 226,
    height: 226,
    rx: 8,
    fill: "url(#paint0_linear_1234_16964)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.67 92.5402V126.44C139.67 132.38 134.84 137.21 128.9 137.21C122.99 137.21 118.13 132.38 118.13 126.44C118.13 120.53 122.99 115.7 128.9 115.7C131.42 115.7 133.67 116.57 135.5 118.01V100.16L107.87 108.02V132.23C107.87 138.17 103.01 143 97.1001 143C91.1601 143 86.3301 138.17 86.3301 132.23C86.3301 126.32 91.1601 121.49 97.1001 121.49C99.5901 121.49 101.84 122.36 103.67 123.77V97.2502C103.67 92.8402 106.34 89.4202 110.57 88.2802L127.91 83.5402C131.42 82.5802 134.39 82.9102 136.49 84.5302C138.62 86.1202 139.67 88.8202 139.67 92.5402Z",
    fill: "url(#paint1_linear_1234_16964)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1234_16964",
    x1: 252,
    y1: 252,
    x2: -34,
    y2: -30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABCCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1234_16964",
    x1: 86.3301,
    y1: 101.303,
    x2: 140.988,
    y2: 105.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F5EF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FECE6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPoster);
export default __webpack_public_path__ + "static/media/empty-poster.a26b576a0d891518d7ccfd39437c7bf1.svg";
export { ForwardRef as ReactComponent };